
const displayName = (parentObject) => {
  var name = '';
  if (parentObject && parentObject.name) {
    name = parentObject.name.charAt(0).toUpperCase() + parentObject.name.slice(1);
  }
  if (parentObject && parentObject.first_name) {
    name = name + ' ' + sentenceCase(parentObject.first_name);
  }
  if (parentObject && parentObject.last_name) {
    name = name + ' ' + sentenceCase(parentObject.last_name);
  }
  return name;
}

const sentenceCase = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const displayMoney = (amount) => {
  const amountInDollars = amount/100;
  return '$' + amountInDollars.toFixed(2);
}

const displayPhoneNumber = (numberStr) => {
  var displayString = '';
  var originalStringCounter = 0;
  for (var i = 0; i < numberStr.length + 2; i++) {
    if (i === 3) {
      displayString = displayString + '-';
    } else if (i === 7) {
      displayString = displayString + '-';
    } else {
      displayString = displayString + numberStr.charAt(originalStringCounter);
      originalStringCounter = originalStringCounter + 1;
    }
  }
  return displayString;
}

const displayCodePhoneNumber = (num_str) => {
  let str = num_str || '';
  let has_code = str && str.length > 2 && str[0] && str[1] && str[0] === '+' && str[1] === '1' ? true : false;
  let cleaned  = str;

  if (has_code) {
    if (str.length >= 12) {
      cleaned = '(' + str[2] + str[3] + str[4] + ') ' + str[5] + str[6] + str[7] + ' ' + str.substr(8);
    }
  }

  return cleaned;
}

export default {
  displayName,
  displayMoney,
  displayPhoneNumber,
  displayCodePhoneNumber,
  sentenceCase,
}
